var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',[_c('li',[_c('h1',[_c('router-link',{attrs:{"to":"/"}},[_c('span',[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"fa-solid fa-mountain-sun","aria-hidden":"true"}})],1),_c('span',[_vm._v("Liam E")])])],1)]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":"#projects"}},[_vm._v("Projects")])])
}]

export { render, staticRenderFns }